import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ICostCenter } from '../../../../../../models/cost-center.model';
import { ICostType } from '../../../../../../models/cost-type.model';
import { SharedDataFacade } from '../../../../../../services/facades/master-data/shared-data.facade';

@Component({
    selector: 'app-import-indirect-cost',
    templateUrl: './import-indirect-cost.component.html',
    styleUrls: [ './import-indirect-cost.component.css' ],
})

export class ImportIndirectCostComponent implements OnInit {

    public importFormArray: FormArray<FormGroup<{
        costTypeId: FormControl<number>;
        costCenterId: FormControl<number>;
        costCt: FormControl<number>;
    }>> = new FormArray([]);

    public costCenters: ICostCenter[] = [];
    public costTypes: ICostType[] = [];
    constructor(private myFormBuilder: FormBuilder,
                private mySharedDataFacade: SharedDataFacade) {
    }

    public async ngOnInit(): Promise<void> {

        this.addRow();
        this.costCenters = await firstValueFrom(this.mySharedDataFacade.fetchCostCenters());
        this.costTypes = await firstValueFrom(this.mySharedDataFacade.fetchCostTypes());
    }

    public addRow(): void {
        const importRow = this.myFormBuilder.group({
            costTypeId: [ null as number, Validators.required ],
            costCenterId: [ null as number, Validators.required ],
            costCt: [ null as number, Validators.compose([ Validators.required, Validators.pattern('^[1-9][0-9]*$') ]) ],
        });
        this.importFormArray.push(importRow);
    }

    public deleteRow(index: number): void {
        this.importFormArray.removeAt(index);
    }
}
